import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Team } from '../../../../shared/model/team/team.model';
import { SGF_API } from '../../../../../shared/api/sgf.api';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private host = `${SGF_API}` + 'global/api/public/equipe';
  private posto: string;
  constructor(
    private httpClient: HttpClient,
  ) {
  }

  listAll(): any {
    this.checkIfHasPosto();
    return this.httpClient.get<Team>(`${this.host}?size=10000&${this.posto}`)
    .pipe(
      catchError(this.handleError)
    );

  }

  page(size: number, page: number, postoId?: any): Observable<any> {
    this.checkIfHasPosto();
    return this.httpClient.get(`${this.host}?size=${size}&page=${page}&${this.posto}&sort=-id`);

  }

  pagePosPosto(size: number, page: number, postoId?: any): Observable<any> {
    this.checkIfHasPosto();
    return this.httpClient.get(`${this.host}?size=${size}&page=${page}&postoId=${postoId}&sort=-id`);

  }

  findById(id: number): Observable<any> {
    return this.httpClient.get<Team>(`${this.host}/${id}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  findByPostoId(id: number): Observable<any> {
    return this.httpClient.get<Team>(`${this.host}/buscar-por-posto/${id}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  add(team: any): Observable<any> {
    const body = JSON.stringify(team);
    return this.httpClient.post(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  updateTeam(team: Team): Observable<any> {
    const body = JSON.stringify(team);

    return this.httpClient.post(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

   deleteTeam(id: number): any {
    return this.httpClient.delete(`${this.host}/${id}`);
  }

  checkIfHasPosto(): void {
    if (sessionStorage.getItem('funcionario')) {
      const user = JSON.parse(sessionStorage.getItem('funcionario'));
      this.posto = user.idPosto ? 'postoId=' + user.idPosto : '';
    }
  }


  httpOptions(token?: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    };
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }

}
